import styled, { css } from 'styled-components'

interface ContainerProps {
  open?: boolean
  hidden?: boolean
}

interface ConcludeProps {
  disabled?: boolean
  disabledClonclude?: boolean
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  align-items: center;
  justify-content: center;

  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  z-index: 2000;

  background: rgba(0, 0, 0, 0.5);

  transition: transform 0.5s ease-in-out;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-100%)')};
`

export const Content = styled.div<ContainerProps>`
  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
  border-radius: 8px;
  padding: 1.5rem;

  @media only screen and (min-width: 600px) {
    max-width: 765px;
    height: auto;
  }

  .imgLesson {
    img {
      margin: 0 auto;
      max-width: 70vw;
      max-height: 70vh;
      transition: transform 0.2s;
      cursor: pointer;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
`

export const ButtonClose = styled.button`
  display: flex;
  cursor: pointer;
  top: 0;
  right: 0;
  border: none;
  color: ${({ theme }) => `rgba(${theme.grayscale[100]})`};

  @media only screen and (min-width: 1080px) {
    background-color: transparent;
    top: 70px;
    right: 150px;
  }
`

export const TitleIdent = styled.div`
  display: center;
  justify-content: center;

  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  @media only screen and (max-width: 400px) {
    display: flex;
    justify-content: center;
    align-items: center;
    h1 {
      text-align: center;
      display: center;
      justify-content: center;
      width: 90%;
    }
  }
`

export const TableForOptions = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 4px;
  width: 96%;
  padding-top: 24px;
  padding-bottom: 2rem;
  margin-left: 1rem;

  @media only screen and (max-width: 400px) {
    margin-left: 0.5rem;
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  line-height: 140%;
  max-width: 95%;

  input {
    margin-left: 1rem;
  }

  label {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
    font-family: 'Montserrat';
    font-style: normal;
    margin-top: 3px;
    margin-left: 1rem;
  }

  .inputModal {
    margin-left: 1rem;
    width: 100%;
    height: 10%;
    line-height: 0.2rem;
    margin-bottom: -1px;
    margin-top: 8px;

    .errorInput {
      /* display: flex; */
      float: right;
      margin-top: -1px;
      small {
        min-height: 1rem;
        justify-content: center;
        align-items: center;
        /* float: right;  */
        font-size: 0.75;
        font-weight: 400;
        margin-top: -50px;
        color: rgb(222, 1, 1);
      }
    }
  }
`

export const InputTextOther = styled.div`
  display: flex;
  align-items: center;
  line-height: 140%;
  margin-top: 2rem;

  input {
    margin-left: 1rem;
  }

  label {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
    font-family: 'Montserrat';
    font-style: normal;
    margin-top: 3px;
    margin-left: 1rem;
  }
`

export const Conclude = styled.div<ConcludeProps>`
  cursor: pointer;
  margin-top: 2rem;
  margin-left: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 14px 21px;
  gap: 10px;

  width: 99.32px;
  height: 43.95px;
  background: ${(props) =>
    props.disabledClonclude
      ? `rgba(${props.theme.primary.base}, 0.5)`
      : `rgb(${props.theme.primary.base})`};
  border-radius: 4px;

  button {
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 700;
  }

  @media only screen and (max-width: 400px) {
    margin-left: 8.5rem;
  }
`
